import React from 'react';
import styled from 'styled-components';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { IconButton } from '@grnhse/seedling/lib/birch/components/buttons';
import { Body } from '@grnhse/seedling/lib/birch/typography';
import CloseIcon from '@grnhse/seedling/lib/birch/icons/close';
import LinkedinIcon from '../icons/linkedin_icon';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix('talent_matching');

const IframeContainer = styled.div`
  flex: 1;
  height: 100%;
  width: 100%;

  iframe {
    width: 100%;
    height: 100%;
    border: none;
    min-height: calc(100vh - 250px);
    display: block;
  }
`;

export type LinkedinHeaderProps = {
  onClose: () => void;
};

export const LinkedinHeader: React.FC<LinkedinHeaderProps> = ({ onClose }) => {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{
        paddingY: 3,
        paddingTop: 0,
        width: '100%',
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <LinkedinIcon />
        <Body>{t('linkedin')}</Body>
      </Stack>
      <IconButton
        icon={CloseIcon}
        label={t('actions.close_panel')}
        onClick={onClose}
        size="md"
      />
    </Stack>
  );
};

export interface LinkedinContentProps {
  iframePath: string;
}

export const LinkedinContent = ({ iframePath }: LinkedinContentProps) => {
  return (
    <IframeContainer>
      <iframe src={iframePath} seamless title="LinkedIn" />
    </IframeContainer>
  );
};
